import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MatMixService {

  // private apiUrl = "http://localhost:3003/api";
  apiUrl = "https://lexipackghana.com:3003/api";

  constructor(private http: HttpClient) { }

  
  
createMatMix(matMixData: any) {
  return this.http.post(this.apiUrl+'/add', matMixData);
}


  // Retrieve all MatMix entries
  getAllMatMix(){
    return this.http.get(this.apiUrl+'/getAll');
  }

  // Retrieve a MatMix entry by its ID
  getMatMixById(matMixId: string) {

    return this.http.get(this.apiUrl+'/getById/'+matMixId);

  }
    // Example method to fetch MatMix data by orderId
    getMatMixByOrderId(orderId: string) {
      const url = `${this.apiUrl}/matMix/byOrderId/${orderId}`; // Adjust endpoint URL
      return this.http.get<any[]>(url);
    }
  updateMatMix(matMixId: string,data:String) {

    return this.http.put(this.apiUrl+'/putById/'+matMixId,data);

  }
  deleteMatmix(matMixId: string) {
    return this.http.delete(this.apiUrl+'/deleteById/'+matMixId);
  }
//many 
  deleteAll(ids: string[]) {
    return this.http.delete<any>(this.apiUrl + '/deleteAllMat', { body: { ids } });
  }
}
